import {computed} from "vue";
import {useRoute, useRouter} from "vue-router";

export function useRoutedTabbedDashboard(routeName: string, id: string | null) {
  const route = useRoute();
  const router = useRouter();

  const activeTab = computed({
    get: () => (route.params.tab as string) || "dashboard",
    set: (value: string) => {
      router.push({
        name: routeName,
        params: {
          id: id,
          tab: value.toLowerCase()
        }
      });
    }
  });

  return {
    activeTab
  };
}
